import { Component, OnInit, Input } from '@angular/core';
import { IDatePickerDirectiveConfig } from 'ng2-date-picker';
import { Dayjs }  from 'dayjs';

@Component({
    selector: 'app-form-group-timepicker',
    templateUrl: './form-group-timepicker.component.html',
    styleUrls: ['./form-group-timepicker.component.scss'],
    standalone: false
})
export class FormGroupTimepickerComponent implements OnInit {

  public timePcikerConfig: IDatePickerDirectiveConfig = {
    showTwentyFourHours: true,
    showSeconds: false,
    minTime: new Dayjs('09:00:00'),
    maxTime: new Dayjs('16:30:00'),
    minutesInterval: 5
  };

  @Input()
  label: string;

  @Input()
  model = '09:00:00';

  @Input()
  disabled: false;

  constructor() { }

  ngOnInit() {
  }

}
